<template>
  <div class="line-item">
    <div class="line-item__header">
      <div>
        Line # {{ lineItem.LineItem }}:
        {{ lineItem.Ingredient }}
      </div>
      <div class="pull-right">
        <a
          v-if="lineItem.Attachments?.length > 0"
          class="line-item__attachment-button"
          @click="downloadAttachment(lineItem)"
        >
          <font-awesome-icon icon="fa-solid fa-download" /> Attachments
        </a>
        <span v-if="lineItem.Status" class="yellow"
          >[{{ lineItem.Status }}]</span
        >
      </div>
    </div>
    <div class="line-item__view">
      <div class="line-item__view-container">
        <div class="line-item__view-column">
          <div v-if="originalView">
            <span class="cc-label-name"
              >Original Ingredient: {{ lineItem.OriginalIngredient }}</span
            >
          </div>
          <div>
            <span class="cc-label-name">Brand: {{ lineItem.Brand }}</span>
          </div>
          <div v-if="originalView">
            <span class="cc-label-name"
              >Original Brand: {{ lineItem.OriginalBrand }}</span
            >
          </div>
          <div>
            <span class="cc-label-name">Source: {{ lineItem.Source }} </span>
          </div>
          <div v-if="originalView">
            <span class="cc-label-name"
              >Original Source: {{ lineItem.OriginalSource }}
            </span>
          </div>
        </div>
        <div class="line-item__view-column right">
          <div>
            <span class="cc-label-name">UKD ID: {{ lineItem.UKDID }}</span>
          </div>
          <div v-if="lineItem.rmc">
            <span class="cc-label-name">RMC: {{ lineItem.rmc }}</span>
          </div>
        </div>
        <div class="line-item__view-column full">
          <div>
            <span class="cc-label-name yellow"
              >Plant: {{ lineItem.PlantName }}
            </span>
          </div>
          <div>
            <span class="cc-label-name"
              >Reviewed By: {{ lineItem.ApprovedBy }}</span
            >
          </div>
          <div>
            <span class="cc-label-name"
              >Reviewed Date: {{ lineItem.ApprovalDate }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useMainStore } from "@/stores/useMainStore";
import { api } from "@/api";
import type { IngredientSubmissionDetail } from "@/Domain/IngredientSubmissionDetail";

const main = useMainStore();

defineProps<{
  lineItem: IngredientSubmissionDetail;
  originalView: boolean;
}>();

const downloadAttachment = function (submission: IngredientSubmissionDetail) {
  return api.getDownload("GetSubmissionDetailsAttachment", {
    jobId: submission.JobId,
    inCartId: submission.IngredientInCartID?.toString() ?? "",
    submissionType: "Ingredient",
  });
};
</script>

<style scoped lang="scss">
.line-item {
  margin-bottom: 10px;
  border: 1px solid #ddd;
  background: #fff;

  &__header {
    display: flex;
    font-size: 13px;
    font-weight: bold;
    padding: 8px 15px;
    border-bottom: 1px solid #e8e8e8;
    background: #efefef;

    .pull-right {
      margin-left: auto;
      margin-top: 0;
    }
  }

  &__attachment-button {
    color: #337ab7;
    font-size: 12px;
    cursor: pointer;
    font-weight: normal;
    margin-top: 2px;
    display: inline-block;
    margin-right: 10px;

    &:hover {
      color: #0a58ca;
    }
  }

  &__view {
    padding: 10px;
  }

  &__view-footer {
    padding: 10px;
    display: block;
    flex-direction: column;
    gap: 12px;
  }

  &__view-container {
    display: flex;
    justify-content: space-between;
    width: 100%;
    flex-wrap: wrap;
  }

  &__view-column {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 50%;

    &.right {
      width: auto;
    }

    &.full {
      width: 100%;
    }
  }

  &__view {
    padding: 10px;
  }

  .yellow {
    color: #ec9e39;
    font-weight: normal;
  }
}

.cc-label-name {
  white-space: pre;
  color: #999;
  font-weight: 700;
  font-size: 12px;
  text-wrap: wrap;
}

.cc-label-name-red {
  white-space: pre;
  color: #b51515;
  font-weight: bold;

  .urgent-icon {
    display: block;
  }
}

.k-grid-header {
  background-color: #dedede;
}
</style>
